import { Component, Input } from "@angular/core";

@Component({
  selector: "uni-accordion-item",
  templateUrl: "./accordion-item.component.html",
})
export class UniAccordionItemComponent {
  /**
   * Name or title of the data displayed in this item
   */
  @Input() public name: string;

  /**
   * Data to be displayed in the item
   *  @deprecated
   */
  @Input() public description: string;
}
